import { post, deleteRequest } from "./helpers";

export const prepareVideoRoom = async (appointmentId, authToken) => {
  const url = `/api/video-call/rooms/${appointmentId}`;
  const headers = authToken
    ? { Authorization: `Bearer ${authToken}` }
    : undefined;
  const result = await post(url, undefined, headers);
  return result.data;
};

export const leaveVideoRoom = async (appointmentId, authToken) => {
  const url = `/api/video-call/rooms/${appointmentId}/participants/@me`;
  const headers = authToken
    ? { Authorization: `Bearer ${authToken}` }
    : undefined;
  const result = await deleteRequest(url, headers);
  return result.data;
};

export const beaconLeaveVideoRoom = (appointmentId, activityId, authToken) => {
  const activityIdQuery = activityId ? `activityId=${activityId}` : null;
  const methodQuery = "_method=DELETE";
  const queries = [activityIdQuery, methodQuery].filter((x) => x).join("&");

  const url = `/api/video-call/rooms/${appointmentId}/participants/@me?${queries}`;
  navigator.sendBeacon(url, JSON.stringify({ token: authToken }));
};

// only users with cookie auth(i.e. intepreter, requester, but not anonymous recipient)
// can delete the room.
export const deleteVideoRoom = async (appointmentId) => {
  const url = `/api/video-call/rooms/${appointmentId}`;
  const result = await deleteRequest(url);
  return result.data;
};
